import styled from 'styled-components';

export const Tags = styled.div`
  padding: 20px 0 0;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;
